import React from "react";
import classes from "./ProgressBar.module.css";

const ProgressBar = (props) => {
  const { CHECKOUT_STEP, checkoutStep } = props;
  return (
    <div className="row">
      <ul className={classes.progressbar}>
        <li className={`${classes.active} ${classes.account}`}>
          <strong>Cart Review</strong>
        </li>
        <li
          className={`${
            CHECKOUT_STEP
              ? checkoutStep >= CHECKOUT_STEP.ADDRESS_SECTION
                ? classes.active
                : ""
              : null
          } ${classes.personal}`}
        >
          <strong>Add Address</strong>
        </li>

        <li
          className={`${
            CHECKOUT_STEP
              ? checkoutStep >= CHECKOUT_STEP.METHOD
                ? classes.active
                : ""
              : null
          }  ${classes.method}`}
        >
          <strong>Shipping Methods</strong>
        </li>
        <li
          className={`${
            CHECKOUT_STEP
              ? checkoutStep >= CHECKOUT_STEP.PAYMENT
                ? classes.active
                : ""
              : null
          }  ${classes.payment}`}
        >
          <strong>Payment Methods</strong>
        </li>
        <li
          className={`${
            CHECKOUT_STEP
              ? checkoutStep > CHECKOUT_STEP.REVIEW
                ? classes.active
                : ""
              : null
          }  ${classes.confirm}`}
        >
          <strong>Completed</strong>
        </li>
      </ul>
    </div>
  );
};

export default ProgressBar;
